import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { useTranslation } from 'react-i18next';

const CrecheTeam = (props) => {
  const { t } = useTranslation();
  const { dataTeam } = props;
  let team = dataTeam.team;
  if (!_.isEmpty(team)) {
    return (
      <div className="bloc-team-day mt-4 box-shadow">
        <div className="title-team bg-blue">{t('creche_life.team_today')}</div>
        <div className="d-flex align-items-stretch justify-content-between">
          <div className="tranche-horaire d-flex align-items-center">
            <div>
              <span>{t('creche_life.morning')}</span>
              <p>{team.presentsMatin}</p>
            </div>
          </div>
          <div className="tranche-horaire d-flex align-items-center">
            <div>
              <span>{t('creche_life.noon')}</span>
              <p>{team.presentsMidi}</p>
            </div>
          </div>
          <div className="tranche-horaire d-flex align-items-center">
            <div>
              <span>{t('creche_life.afternoon')}</span>
              <p>{team.presentsApresMidi}</p>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return "";
  }
};

CrecheTeam.propTypes = {
  dataTeam: PropTypes.object,
};

export default CrecheTeam;
